import { getAxiosClient } from "../../axios-client";
import { PricelistEditBody, PricelistEditResponse } from "./types";

const axiosClient = getAxiosClient();
export const pricelistupdate = async (body: PricelistEditBody) => {
  return await axiosClient.ax.put<PricelistEditResponse>(
    "Pricelist/Update",
    body
  );
};
